import React from 'react'
import PropTypes from 'prop-types'
import PlacementItem from 'components/AdListItem/PlacementItem'

export const ToplistPlacementItem = (props) => {
  const formattedPlacement = {
    advertiser: { type: 'store' }, // Hardcoded, since toplistings will probably always be from stores
    content: props.content,
    cta: props.cta,
    subject: props.subject,
    toplistingLabel: props.productLabel || 'Listettan',
    impressionUrl: props.impressionUrl,
  }

  return <PlacementItem ad={formattedPlacement} url={props.clickUrl} imageSrc={props.imageUrl} />
}

ToplistPlacementItem.propTypes = {
  content: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  productLabel: PropTypes.string,
  impressionUrl: PropTypes.string.isRequired,
  clickUrl: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
}

export default ToplistPlacementItem
